<template>
  <div class="meterReadings">
    <v-row>
      <v-col>
        <breadcrumb :items="breadcrumbs" />
      </v-col>
      <v-col class="text-right">
        <v-btn
          v-if="can('meter-reading-create')"
          color="primary"
          class="mb-5"
          @click="showAddMeterDialog = true"
        >
          <v-icon
            left
            size="22"
          >
            {{ icons.mdiShapeSquarePlus }}
          </v-icon>
          Add Meter Reading
        </v-btn>
      </v-col>
    </v-row>
    <meter-readings-table
      :meter-reading-url="meterReadingUrl"
      :show-add-meter-dialog="showAddMeterDialog"
      @add-meter-dialog-open="showAddMeterDialog = true"
      @add-meter-dialog-close="showAddMeterDialog = false"
    />
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import {
  mdiShapeSquarePlus,
} from '@mdi/js'
import hasPermission from '@/mixins/hasPermission'
import BreadCrumb from '@/components/partials/BreadCrumb.vue'
import MeterReadingsTable from '@/components/tables/MeterReadingsTable.vue'

export default {
  components: {
    breadcrumb: BreadCrumb,
    'meter-readings-table': MeterReadingsTable,
  },
  mixins: [hasPermission],
  data() {
    return {
      showAddMeterDialog: false,
      breadcrumbs: [
        {
          text: 'Dashboard',
          disabled: false,
          to: { name: 'dashboard' },
        },
        {
          text: 'Billings',
          disabled: true,
          to: { name: 'meter-readings' },
        },
      ],
      icons: {
        mdiShapeSquarePlus,
      },
    }
  },
  computed: {
    ...mapGetters(['selectedStation']),
    meterReadingUrl() {
      return `meter-readings?station_id=${this.selectedStation}`
    },
  },
}
</script>
